<div *ngIf="realTimeFeatureEnabled && canManageSettings" class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li *ngIf="virtualAgentIntegrationEnabled" [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::RealTimeVirtualAgentIntegration' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-real-time-virtual-agent-settings></ca-real-time-virtual-agent-settings>
      </ng-template>
    </li>
    <li *ngIf="voiceBiometricsIntegrationEnabled" [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::RealTimeVoiceBiometricsIntegration' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-real-time-voice-biometrics-settings></ca-real-time-voice-biometrics-settings>
      </ng-template>
    </li>
    <li *ngIf="generativeQnAFeatureEnabled" [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::RealTimeGenerativeQnA' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-generative-qa-settings></ca-generative-qa-settings>
      </ng-template>
    </li>
    <li *ngIf="performanceInsightsEnabled" [ngbNavItem]="5">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::PerformanceInsights' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <performance-insights-settings></performance-insights-settings>
      </ng-template>
    </li>
    <li *ngIf="virtualTranslatorEnabled" [ngbNavItem]="6">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::VirtualTranslator' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <virtual-translator-settings></virtual-translator-settings>
      </ng-template>
    </li>
    <li [ngbNavItem]="7">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AgentAssist:AskManager' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-ask-manager-settings></ca-ask-manager-settings>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
